import axios from 'axios'
import global from '@/global/variable.js'


// 获取过磅列表
export function getHistoryList(data) {
  const url = global.requestUrl + '/weighbridge/list?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.startDate + '&endDate=' + data.endDate 
              + '&type=' + data.type + '&status=' + data.status + '&plateNumber=' + data.plateNumber 
              + '&supplier=' + data.supplier + '&material=' + data.material
  return axios.get(url)
}

// 人脸闸机放行
export function updateOne(data) {
  const url = global.requestUrl + '/equip/openRail?rail=' + data.rail + '&reason=' + data.reason
  return axios.get(url)
}

